import {
  Box,
  Divider,
  Grid,
  Paper,
  SxProps,
  Typography,
  TypographyTypeMap,
} from "@mui/material";
import { FC } from "react";
import { ExtendedAttributes } from "../model/form-configuration";

const paperStyle: SxProps = {
  padding: 1,
  m: 0,
};

type align = "inherit" | "left" | "center" | "right" | "justify";

const HeaderMessage: FC<{
  extendedAttributes: ExtendedAttributes;
  message: string;
}> = ({ extendedAttributes, message }) => {
  let bgColor: string = "#ffffff";
  let fontColor: string = "#000000";
  let fontWeight: string = "regular";
  let variant: string = "body1";
  let align: align = "left";
  let padding: number = 1;
  let margin: number = 0;
  let elevation: number = 2;

  if (extendedAttributes) {
    if (extendedAttributes.elevation) elevation = +extendedAttributes.elevation;
    if (extendedAttributes.margin) margin = +extendedAttributes.margin;
    if (extendedAttributes.padding) padding = +extendedAttributes.padding;
    if (extendedAttributes.fontWeight)
      fontWeight = extendedAttributes.fontWeight;
    if (extendedAttributes.bgColor) bgColor = extendedAttributes.bgColor;
    if (extendedAttributes.fontColor) fontColor = extendedAttributes.fontColor;
    if (extendedAttributes.variant) variant = extendedAttributes.variant;
    if (extendedAttributes.align) align = extendedAttributes.align as align;
  }
  return (
    <Grid item xs={2} sm={4} md={8} xl={16}>
      <Box sx={{ padding: 0, my: 0, mx: 2 }}>
        <Paper
          elevation={0}
          sx={{ m: margin, padding: padding, bgcolor: bgColor }}
        >
            {/* TODO: fix fontWeigth should be string literal and not object. Change all config */}
          <Typography
            sx={{ fontWeight: { fontWeight } }}
            color={fontColor}
            align={align}
            variant={variant as TypographyTypeMap["props"]["variant"]}
            component="div"
          >
            {message}
          </Typography>
          {extendedAttributes && extendedAttributes.hasDivider && (
            <Divider sx={{ my: 2 }} />
          )}
        </Paper>
      </Box>
    </Grid>
  );
};

export default HeaderMessage;
//HeaderMessage.whyDidYouRender = true;
